import { Component, TemplateRef } from '@angular/core';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { DutchDatePipe } from '../../../pipes/dutch-date.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-queue-message-details',
  standalone: true,
  imports: [
    CommonModule,
    LoaderComponent,
    ModalHeaderComponent,
    DutchDatePipe
  ],
  templateUrl: './queue-message-details.component.html',
  styleUrl: './queue-message-details.component.scss'
})
export class QueueMessageDetailsComponent {
  modalTitle: string = '';
  loading: boolean = false;
  item: any | null = null;
  itemId: any | null = null;
  reloadItems: boolean = false;
  message: string = '';

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) {
    this.loading = false;
  }

  ngOnInit() {
    this.getItem();
  }

  formatJson(jsonText: any) {
    if (!jsonText || jsonText == "") {
      return "";
    }
    try {
      const obj = JSON.parse(jsonText);
      return JSON.stringify(obj, null, 2) ?? jsonText;
    } catch (error) {
      return "" + jsonText;
    }
  }

  getItem() {
    let itemId = this.item['id'];
    let self = this;

    return this.apiService.get('/office/queue-messages/' + itemId).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  process () {
    let self = this;
    self.loading = true;
    self.message = '';
    return this.apiService.get('/office/queue-messages/'+self.item['id']+'/process').then(function (response: any) {
      self.message = response['message'];
      self.getItem();
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }

  reset () {
    let self = this;
    self.loading = true;
    self.message = '';
    return this.apiService.get('/office/queue-messages/'+self.item['id']+'/reset-process').then(function (response: any) {
      self.message = response['message'];
      self.getItem();
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
